import ManualTradeNews from './ManualTradeNews';

export default ManualTradeNews;
